import water_lab_testing from "../assest/water_lab_testing.jpg";
import wastewater_consultancy from "../assest/wastewater_consultancy.jpg";
import industrial_boiler_cleaning from "../assest/industrial_boiler_cleaning.avif";
import water_treatment_plant from "../assest/water_treatment_plant.avif";
import IMG1 from "../assest/water.jpg";

export const serviceData = [
  {
    id: 1,
    title: "Boiler and Condenser Descaling",
    image: industrial_boiler_cleaning,
    description:
      "Our skilled team delivers expert descaling services for boilers and condensers, ensuring enhanced efficiency and prolonged lifespan. Using advanced techniques and eco-friendly solutions, we effectively remove scale buildup, improve performance, and reduce energy consumption.",
    features: [
      "Professional team with extensive experience",
      "Advanced descaling techniques",
      "Eco-friendly solutions",
      "Enhanced system efficiency",
      "Scale prevention programs",
      "Performance monitoring",
    ],
  },
  {
    id: 2,
    title: "Water Treatment Equipment Installation",
    image: water_treatment_plant,
    description:
      "Our specialists handle complete erection and commissioning of water treatment equipment. With precision and adherence to industry standards, we ensure seamless integration and optimal performance.",
    features: [
      "Expert installation services",
      "Industry standard compliance",
      "Comprehensive system integration",
      "Ongoing support and maintenance",
      "Technical documentation",
      "24/7 support services",
    ],
  },
  {
    id: 3,
    title: "Industrial Water Balancing Audit",
    image: IMG1,
    description:
      "Our experts provide thorough industrial water balancing audits to optimize your water usage. By identifying inefficiencies and recommending actionable improvements, we help reduce costs and enhance sustainability.",
    features: [
      "Detailed water usage analysis",
      "Cost-saving recommendations",
      "Sustainability improvements",
      "Efficiency optimization",
      "ROI calculations",
      "Implementation guidance",
    ],
  },
  {
    id: 4,
    title: "Water Treatment Consultancy",
    image: wastewater_consultancy,
    description:
      "We offer consultancy services for wastewater treatment, including effluent treatment plants. Our comprehensive solutions include site supervision and timely system installations.",
    features: [
      "Expert consultation services",
      "Site supervision",
      "System installation guidance",
      "Timely project execution",
      "Regulatory compliance",
      "Operation optimization",
    ],
  },
  {
    id: 5,
    title: "Laboratory Testing Services",
    image: water_lab_testing,
    description:
      "We provide reliable laboratory testing services adhering to industry standards. Our advanced facilities enable precise scientific experiments and measurements under controlled conditions.",
    features: [
      "Advanced testing facilities",
      "Industry standard compliance",
      "Accurate measurements",
      "Quick turnaround time",
      "Quality assurance protocols",
      "Regular calibration",
    ],
  },
  {
    id: 6,
    title: "Maintenance & Support Services",
    image:
      "https://www.innovapptive.com/hubfs/2022-219-Overcoming-Maintenance-Management-Challenges-in-the-Chemical-Industry.webp",
    description:
      "We provide comprehensive maintenance and support services for all water treatment systems. Our team ensures optimal performance through regular maintenance, troubleshooting, and system optimization.",
    features: [
      "Preventive maintenance",
      "Emergency support",
      "System optimization",
      "Regular inspections",
      "Performance monitoring",
      "Technical support",
    ],
  },
];
